<template>
    <div class="maint-header-banner">
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="560px"
            append-to-body
            custom-class="maint-banner-help-dialog"
        >
            <div class="panel-desc">
                <slot></slot>
            </div>
            <div slot="footer">
                <el-button type="primary" size="small" @click="dialogVisible = false">知道了</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
/**
 * 运维模块说明内容容器：内容由 slot 提供，打开入口由运维顶栏「说明」按钮触发。
 * 最后更新：2026-09-09
 */
export default {
    name: 'MaintCollapsibleBanner',
    inject: {
        registerMaintHelp: { default: null },
        unregisterMaintHelp: { default: null }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            default: 'el-icon-info'
        },
        /** 兼容旧用法 */
        storageKey: {
            type: String,
            default: ''
        },
        defaultCollapsed: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            dialogVisible: false
        };
    },
    computed: {
        dialogTitle() {
            return `${this.title} - 说明`;
        }
    },
    mounted() {
        if (typeof this.registerMaintHelp === 'function') {
            this.registerMaintHelp(this.openHelp);
        }
    },
    beforeDestroy() {
        if (typeof this.unregisterMaintHelp === 'function') {
            this.unregisterMaintHelp();
        }
    },
    methods: {
        openHelp() {
            this.dialogVisible = true;
        }
    }
};
</script>

<style scoped>
.maint-header-banner {
    /* 可见入口已上移到运维顶栏；此处仅保留说明弹窗节点，不占布局高度 */
    flex: 0 0 0;
    height: 0;
    width: 0;
    overflow: visible;
    margin: 0;
    padding: 0;
    border: 0;
}

.panel-desc {
    color: #475569;
    font-size: 13px;
    line-height: 1.7;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.panel-desc ::v-deep .desc-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.panel-desc ::v-deep .desc-item code {
    font-family: Consolas, monospace;
    font-size: 12px;
    background: rgba(226, 232, 240, 0.8);
    padding: 1px 5px;
    border-radius: 4px;
    color: #0f172a;
}

.panel-desc ::v-deep .desc-badge {
    padding: 2px 8px;
    font-size: 11px;
    font-weight: 600;
    border-radius: 4px;
    flex-shrink: 0;
    margin-top: 1px;
}

.panel-desc ::v-deep .badge-primary {
    background: rgba(79, 70, 229, 0.1);
    color: #4f46e5;
    border: 1px solid rgba(79, 70, 229, 0.2);
}

.panel-desc ::v-deep .badge-warning {
    background: rgba(217, 119, 6, 0.1);
    color: #d97706;
    border: 1px solid rgba(217, 119, 6, 0.2);
}

.panel-desc ::v-deep .badge-success {
    background: rgba(16, 185, 129, 0.1);
    color: #10b981;
    border: 1px solid rgba(16, 185, 129, 0.2);
}
</style>

<style>
.maint-banner-help-dialog .el-dialog__body {
    padding: 12px 20px 8px;
}

.maint-banner-help-dialog .el-dialog__header {
    padding: 14px 20px 10px;
}

.maint-banner-help-dialog .el-dialog__footer {
    padding: 8px 20px 14px;
}
</style>
